<template>
  <md-card>
    <md-card-header class="md-card-header-icon md-card-header-blue">
      <div class="card-icon">
        <md-icon>groups</md-icon>
      </div>
      <h4 class="title">
        Travellers
      </h4>
    </md-card-header>

    <md-card-content>
      <template v-if="manifest.bookings && manifest.bookings.length">
        <div
          class="md-layout booking-row"
          v-for="booking in manifest.bookings"
          :key="booking.id"
        >
          <md-card>
            <h6 class="md-layout-item md-size-100">
              Booking Reference:
              <router-link
                v-if="$allowed('crm.route.booking')"
                :to="{ name: 'Booking Profile', params: { id: booking.id } }"
                >{{ booking.id }}</router-link
              >
              <template v-else>{{ booking.id }}</template>
            </h6>
            <traveller-item
              class="md-layout-item md-size-100"
              v-for="traveller in booking.travellers"
              :key="traveller.id"
              :traveller="traveller"
            />
          </md-card>
        </div>
      </template>
    </md-card-content>
  </md-card>
</template>

<script>
import TravellerItem from "./TravellerItem.vue";

export default {
  props: {
    manifest: {
      bookings: []
    }
  },

  components: {
    TravellerItem
  },

  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.booking-row {
  .md-card {
    margin: 5px 0px;
  }
  h6 {
    margin: 15px 0px 5px;
  }
}
</style>
